<template>
  <div class="form-group input-select">
    <label :for="id">{{ label }}</label>
    <select v-bind="$attrs" v-on="listeners">
      <option v-for="opt in options" :key="opt.value" :value="opt.value">
        {{ opt.text }}
      </option>
    </select>
    <material-icon name="arrow_drop_down" />
  </div>
</template>

<script>
export default {
  name: "input-select",
  inheritAttrs: false,
  props: {
    id: {
      default: "",
      type: String,
    },
    label: {
      default: "Label",
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners,
        input: (evt) => this.$emit("input", evt.target.value),
      };
    },
  },
};
</script>
